"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ButtonGroup = _interopRequireDefault(require("../ButtonGroup"));

/**
 * DEPRECATED - only exists for backwards compatibility
 */
var _default = _ButtonGroup["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Button/ButtonGroup.js
// module id = 480
// module chunks = 0